import angular from 'angular';

import angularResource from 'angular-resource';

import cachedResource from './services/cached-resource';
import countryData from './services/country-data';
import signupDataStore from './services/signup-data-store';
import userTypes from './services/user-types';
import usageTypes from './services/usage-types';
import exampleTypes from './services/example-types';
import events from './constants/events';
import usaStates from './services/usa-states';

export default angular.module('data', [angularResource])
    .factory('cachedResource', cachedResource)
    .factory('countryData', countryData)
    .factory('signupDataStore', signupDataStore)
    .factory('userTypes', userTypes)
    .factory('usageTypes', usageTypes)
    .factory('exampleTypes', exampleTypes)
    .factory('usaStates', usaStates)
    .constant('events', events)
    .name;



// WEBPACK FOOTER //
// ./data/data-module.js